import { apiClient, etOne, createOne, updateOne, deleteOne, getOneBy} from "./Api";

const MODULE = 'song';

export function getSong(id) {
	return getOne(MODULE, id);
}

export function getSongsByName(name) {
	return apiClient.get(`${MODULE}?name=${name}&maxResults=10`);
}

export function getSongByNameAndArtist(name, artist) {
	return apiClient.get(`${MODULE}?name=${name}&artist=${artist}&maxResults=10`);
}

export function createSong(data) {
	return createOne(MODULE, data);
}

export function updateSong(data) {
	return updateOne(MODULE, data);
}

export function deleteSong(id) {
	return deleteOne(MODULE, id);
}
